import { ValueRendererProps } from '@src/components/combobox/Combobox';
import { Badge } from '@/components/ui/badge';
import { CustomTooltip } from '@src/components/tooltip/Tooltip';
import { Cross1Icon, LinkBreak2Icon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';

export const FiltersRenderer = ({ value, onValueChange, options, children, disabled }: ValueRendererProps) => {
  return (
    <div className="w-full flex flex-wrap items-center">
      {(value || []).map((option) => {
        const isValueValid = options?.find((opt) => opt.value === option.value);
        return (
          <Badge className={cn(`mr-2 my-1 px-2 py-1 max-w-[200px]`, { 'opacity-50': disabled })} variant="secondary" key={option.label}>
            <CustomTooltip content={isValueValid ? option.label : 'The associated object was deleted'}>
              <div className="flex items-center truncate font-light text-sm">
                {!isValueValid && <LinkBreak2Icon className="text-red-500 mr-2"/>}
                {option.label}
              </div>
            </CustomTooltip>
            {!disabled && (
            <CustomTooltip content="Remove item">
              <Cross1Icon
                className={cn(
                  "ml-1 cursor-pointer max-w-3 min-w-3",
                )}
                onClickCapture={() => {
                  onValueChange?.((value || []).filter((opt) => opt.value !== option.value));
                  }}
                />
              </CustomTooltip>
            )}
          </Badge>
        )}
      )}
      {children}
    </div>
  );
}
